import type { FlagType } from '../schemas/flag';

/**
 * Whether the UI offers percentage rollouts at all.
 *
 * Off for now: rollouts are not being used yet. While this is `false` the UI
 * shows no Rollout column (flags list, override table), no "Rollout %" field in
 * the override dialog, and no "gated at N%" / "No rollout gate" notes.
 *
 * It hides the UI only. Toggling a default, an environment default or an
 * existing override still carries its stored `rolloutPercentage` through
 * unchanged (`defaultWriteFrom`, `environmentDefaultWriteFrom`, the override
 * toggle), so a gate set before this was switched off is not dropped by a
 * click. Flip it to bring every rollout control back at once.
 */
export const ROLLOUT_UI_ENABLED = false;

/** A `salesforce` flag never offers a rollout — the API refuses a percentage on one (D6). */
export function offersRollout(type: FlagType): boolean {
    return ROLLOUT_UI_ENABLED && type !== 'salesforce';
}
